import { Checkbox, CheckboxProps } from '@shape-ds/components';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

export const FormCheckbox = <T extends FieldValues>({
  name = 'checkbox',
  className,
  disabled = false,
  ...props
}: Omit<CheckboxProps, 'checked'>) => {
  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => (
        <div className={`${name?.replace(/\./g, '-')} ${className}`}>
          <Checkbox
            onChange={onChange}
            disabled={disabled}
            checked={value}
            className={className}
            {...props}
          />
        </div>
      )}
    />
  );
};
